// refactor sass to stylejs (no theme usage)
import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';
import UiPopover from 'ui-components/ui-popover/UiPopover';

export const StyledTag = styled('div')(
  () => css`
    .tag-component {
      .tag-section {
        background: #ffffff;
        border: 1px solid #eeeeee;
        box-sizing: border-box;
        border-radius: 6px;
        width: 378px;
        height: 44px;
        input {
          border: unset;
        }
        .tag-icon {
          float: left;
          padding: 11px;
          cursor: pointer;
        }
        .MuiTypography-root {
          .color {
            width: 16px;
            height: 16px;
            border-radius: 50%;
            background-color: green;
          }
        }
      }
      .text {
        color: #6c879b;
        font-size: 0.625rem;
        margin-top: 5px;

        &.error {
          color: #f16063;
          font-weight: bold;
        }
      }
      .tags {
        flex-wrap: wrap;
        .tag {
          margin-top: 16px;
          .tag-label {
            margin-left: 10px;
            padding: 8px;
            width: fit-content;
            height: 40px;
            background: rgba(252, 159, 20, 0.2);
            border: 1px solid #fc9f14;
            box-sizing: border-box;
            border-radius: 6px;
            .icon {
              opacity: 0.5;
              margin-right: 5px;
              cursor: pointer;
            }
          }
        }
      }
      .color-circle {
        border-radius: 50%;
        min-width: 16px;
        min-height: 16px;
        max-width: 16px;
        max-height: 16px;
        position: relative;
        cursor: pointer;
      }
      .submit-tag {
        margin-right: 8px;
        min-width: 120px;
      }
    }

    @media (max-width: 370px) {
      .tag-component {
        .tag-component-wrapper {
          flex-wrap: wrap;
        }
        .submit-tag {
          width: 100%;
          margin-right: 0;
          margin-top: 10px;
        }
      }
    }
  `
);

export const StyledTagPopover = styled(UiPopover)(
  () => css`
    .ui-tag-colors {
      justify-content: space-around;
    }
    .color1 {
      background-color: #a6a9af;
      border-radius: 50%;
      width: 16px;
      height: 16px;
      position: relative;
      cursor: pointer;
    }
    .color2 {
      background-color: #f88989;
      border-radius: 50%;
      width: 16px;
      height: 16px;
      position: relative;
      cursor: pointer;
    }
    .color3 {
      background-color: #ce82c6;
      border-radius: 50%;
      width: 16px;
      height: 16px;
      position: relative;
      cursor: pointer;
    }
    .color4 {
      background-color: #fc9f14;
      border-radius: 50%;
      width: 16px;
      height: 16px;
      position: relative;
      cursor: pointer;
    }
    .color5 {
      background-color: #547a9c;
      border-radius: 50%;
      width: 16px;
      height: 16px;
      position: relative;
      cursor: pointer;
    }
    .color6 {
      background-color: #199ba3;
      border-radius: 50%;
      width: 16px;
      height: 16px;
      position: relative;
      cursor: pointer;
    }
    .color7 {
      background-color: #97bd66;
      border-radius: 50%;
      width: 16px;
      height: 16px;
      position: relative;
      cursor: pointer;
    }
    .color8 {
      background-color: #738adc;
      border-radius: 50%;
      width: 16px;
      height: 16px;
      position: relative;
      cursor: pointer;
    }
    .color9 {
      background-color: #f16063;
      border-radius: 50%;
      width: 16px;
      height: 16px;
      position: relative;
      cursor: pointer;
    }
    .active {
      width: 16px;
      height: 16px;
      position: relative;
      &::after {
        position: absolute;
        left: 2px;
        top: 2px;
        content: '';
        z-index: 0;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        border: 2px solid white;
      }
    }
  `
);
